
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
const LiteYouTubeEmbed = dynamic(() => import('react-lite-youtube-embed'));
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
const CallToAction = dynamic(() => import('@/components/CallToAction'));
const Features2 = dynamic(() => import('@/components/Features2'));
const Footer = dynamic(() => import('@/components/layout/Footer'));
const LandingPageNavigation = dynamic(() => import('@/components/layout/LandingPageNavigation'));
const ButtonLink = dynamic(() => import('@/components/links/ButtonLink'));
const Seo = dynamic(() => import('@/components/Seo'));
const Testimonials = dynamic(() => import('@/components/Testimonials'));
import useLocale from 'next-translate/useTranslation';
const Templates = () => {
    const { t, lang } = useLocale('tools');
    return (<main className='relative bg-gray-100 dark:bg-slate-900'>
      {/* <Banner /> */}
      <Seo templateTitle={lang === 'en' ? 'AI Writing Tools & Generators' : t('Tools')} description={t('Easy-Peasy.AI is trained on industry best practices and proven examples to generate high-quality copy for over 100 different use-cases.')}/>
      <div className='relative bg-white dark:bg-slate-900'>
        <div className='mx-auto'>
          <div className='relative z-10 bg-white pb-8 dark:bg-slate-900  lg:w-full'>
            <div className='relative  bg-white dark:bg-slate-900'>
              <div className='mx-auto'>
                <LandingPageNavigation />

                <main className='mx-auto mt-16 max-w-7xl px-4 sm:mt-24 sm:px-6 lg:mt-32'>
                  <div className='lg:grid lg:grid-cols-12 lg:gap-8'>
                    <div className='relative z-30 sm:text-center md:mx-auto md:max-w-2xl lg:col-span-6 lg:text-left'>
                      <h1>
                        <span className='rounded bg-primary-50 px-2.5 py-1 text-xl font-semibold text-primary-600 dark:bg-slate-800'>
                          200+ {t('Tools')}
                        </span>
                        <span className='mt-1 block text-4xl font-bold tracking-tight sm:text-5xl '>
                          <span className='block text-gray-900 dark:text-slate-200'>
                            {t('Get high-quality copy')}
                          </span>
                          <span className='block text-primary-600'>
                            {t('written fast with AI')}
                          </span>
                        </span>
                      </h1>
                      <p className='mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl'>
                        {t('Easy-Peasy.AI is trained on industry best practices and proven examples to generate high-quality copy for over 100 different use-cases.')}
                      </p>
                      <div className='mt-5'>
                        <ButtonLink href='/login' variant='dark'>
                          {t('Get started for free')}
                        </ButtonLink>
                      </div>
                    </div>
                    <div className='relative mt-12 sm:mx-auto sm:max-w-lg lg:col-span-6 lg:mx-0 lg:mt-0 lg:flex lg:max-w-none lg:items-center'>
                      <div className='relative mx-auto w-full rounded-md bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 p-2 shadow-lg lg:max-w-xl'>
                        <LiteYouTubeEmbed id='b2M_0H4O9gY' title='How To Use Easy-Peasy.AI Templates' poster='hqdefault'/>
                      </div>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Features2 showAll={true}/>

      <Testimonials />
      <CallToAction preset='templates'/>
      <Footer />
    </main>);
};
export default Templates;

    async function __Next_Translate__getStaticProps__1a11b03d4a9__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/templates/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a11b03d4a9__ as getStaticProps }
  